import { useState } from "react";

function getRandomNumber() {
  return Math.round(Math.random() * 9999);
}
export default function useWhitelabelPreviewUrl(domainName: string) {
  const [randomNumber, setRandomNumber] = useState(getRandomNumber());

  return {
    whitelabelPreviewUrl: `https://${domainName}?token=${randomNumber}`,
    refreshWhitelabelPreviewUrl: () => setRandomNumber(getRandomNumber),
  };
}
